// @flow
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';

import Text from './Typography';
import Card from './Card';

const PatientEducation = () => {
  const { t } = useTranslation('patientEducation');
  return (
    <Card noShadow noBorder className='patient-education'>
      <Text paragraph className='patient-education__content'>
        {
          // eslint-disable-next-line i18next/no-literal-string
        }
        <Trans
          i18nKey='education_content'
          t={t}
          components={[
            <span />,
            <bold />
          ]}
        />
      </Text>
    </Card>
  );
};

export default PatientEducation;



// WEBPACK FOOTER //
// ./src/components/shared/PatientEducation.js